export default __webpack_public_path__ + "img/BB_RTK_NOMA_EF.d717eb809f05152856e7c66d3048ddf6.jpg";